import axios from "axios";
import { serialize } from "object-to-formdata";
import { createUrl } from "./createUrl";

export default class FnrFetch2 {
  constructor(url, postData, serializeData) {
    this.cancelSource = axios.CancelToken.source();

    if (url) this.url = url;
    if (postData) this.postData = postData;
    if (serializeData) this.serializeData = serializeData;
  }

  post(url, postData) {
    if (!url && this.url) url = this.url;
    if (!postData && this.postData) postData = this.postData;

    return new Promise((fnrFetchResolve, fnrFetchReject) => {
      const axiosInfo = {
        method: "post",
        url: createUrl(url),
        cancelToken: this.cancelSource.token,
        withCredentials: true,
      };

      if (postData) axiosInfo.data = this.getFormData(postData);

      axios(axiosInfo)
        .then((response) => {
          if (response.data.success) fnrFetchResolve(response.data);
          fnrFetchReject(response.data);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) fnrFetchReject(error);
        });
    });
  }

  getFormData(data = {}) {
    if (this.serializeData) {
      // this is helpful for nested objects... depending on the structure the backend is expecting
      return serialize(data);
    } else {
      const formData = new FormData();
      if (typeof data === "object")
        for (let key in data) formData.append(key, data[key]);

      return formData;
    }
  }

  cancel() {
    this.cancelSource.cancel();
  }

  mock(returnData, delay = 0.5) {
    return new Promise((resolve, reject) => {
      setTimeout(
        () =>
          returnData.success
            ? resolve(returnData)
            : reject(returnData.error, returnData),
        delay * 1000
      );
    });
  }
}
